module.exports = __webpack_public_path__ + "img/trash.be13e611.svg";